
























import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import * as _ from 'lodash';

@Component
export default class AutoSuggestSearchField extends Vue {
  @Prop(String) public id: string;
  @Prop(String) public placeholder: string;
  @Prop(String) public defaultSearchText: string;
  @Prop(Array) public suggestions: string[];
  @Prop({type: Number, default: 2}) public minCharactersForShowingSuggestions: number;

  localSearchText: string = '';

  private debounceMilliseconds: 250;
  private debounceTermSuggestions;

  mounted() {
    this.localSearchText = this.defaultSearchText;
    this.$refs.autocompleteInput['searchInput'] = this.defaultSearchText;

    this.debounceTermSuggestions = _.debounce(() => {
      this.triggerSuggestionsUpdate();
    }, this.debounceMilliseconds);
  }

  triggerSuggestionsUpdate() {
    this.$emit('updateSuggestions', this.localSearchText);
  }

  get suggestionsData() {
    return [{data: this.hasMinCharactersForShowingSuggestions ? this.suggestions : []}];
  }

  get translatedPlaceholder() {
    return this.$i18n.tc(this.placeholder);
  }

  get hasMinCharactersForShowingSuggestions() {
    return this.localSearchText.length >= this.minCharactersForShowingSuggestions;
  }

  get hasSearchText() {
    return this.localSearchText.length > 0;
  }

  resetSearchText() {
    this.localSearchText = '';
    this.$refs.autocompleteInput['searchInput'] = '';
    this.updateSearchText();
    this.submitHook();
  }

  updateSuggestions() {
    if (this.localSearchText.length > this.minCharactersForShowingSuggestions) {
      this.debounceTermSuggestions();
    }
  }

  onInputChange(text) {
    this.localSearchText = text;
    this.updateSuggestions();
    this.updateSearchText();
  }

  selectHandler(text) {
    if (!this.suggestions || this.suggestions.length === 0) {
      // Sometimes the vue-autosuggest component keeps at least the last selected suggestion in the "cache",
      // if the users presses Enter, while no text is in the input, the vue-autosuggest component still has
      // the last selection internally selected calls this method with an old suggestion in text.
      // The user can never manually select an autosuggested value, while
      // this.suggestions.length !== 0, because the suggestions are not displayed if that's the case.
      this.submitHook();
      return;
    }

    if (text !== undefined && text !== null) {
      this.localSearchText = text.item;
    }

    this.updateSearchText();
    this.submitHook();
  }

  @Emit('change')
  public updateSearchText() {
    return this.localSearchText;
  }

  @Emit('submitHook')
  public submitHook() {
    return;
  }
}
